import axios from "axios";
import { baseURL } from "../config/api";

export const post_CreateOrUpdateInvoice = (appointmentId: number, userId: number) => {
    return axios({
        url: `${baseURL}invoices/CreateOrUpdateInvoiceForAppointment?appointmentId=${appointmentId}&userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false
    }).then(response => response.data);
}

export const getInvoiceSummary = (id: number) => {
    return getFetch(`invoices/GetInvoiceSummaryByAppointmentId/${id}`)
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}